import request from '@/utils/request'

let Supply_detail = {

  /*企业详情列表*/
  list(data) {
    return request._post('/shop/plus.supply_detail.Index/index', data);
},
/*添加企业详情*/
add(data) {
    return request._post('/shop/plus.supply_detail.Index/add', data);
},
/*修改企业详情*/
edit(data) {
    return request._post('/shop/plus.supply_detail.Index/edit', data);
},
/*删除企业详情*/
del(data) {
    return request._post('/shop/plus.supply_detail.Index/del', data);
},
/*企业详情详情*/
detail(data) {
  return request._post('/shop/plus.supply_detail.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.supply_detail.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.supply_detail.Setting/getSetting', data, errorback);
    },
}
export default Supply_detail;



// WEBPACK FOOTER //
// ./src/api/supply_detail.js